export default "__VITE_ASSET__8c39b0b4__"